<template>
    <div>
        <div class="c-box c-box--alpha">
            <div class="c-box__header">
                <div class="c-box__title">
                    Entity Events (last 100)
                </div>
            </div>
            <template v-if="is_loading">
                <loader></loader>
            </template>
            <template v-else>
                <div class="c-box__content">
                    <b-table
                            stacked="lg"
                            :items="entity_events"
                            :fields="table_fields"
                            :show-empty="true"
                            empty-text="There are events available."
                            :busy="is_loading"
                    >
                        <template v-slot:table-busy>
                            <loader>loading events...</loader>
                        </template>
                        <template v-slot:cell(entity)="data">
                            {{ data.item.entity_id }} / {{ data.item.entity_name }}
                        </template>
                        <template v-slot:cell(server_id)="data">
                            {{ data.item.event_data.server_id }}
                        </template>
                        <template v-slot:cell(event_time)="data">
                            {{ $moment.unix(data.item.event_time).format('YYYY-MM-DD HH:mm:ss') }}
                        </template>
                        <template v-slot:cell(event_type)="data">
                            {{ data.item.event_data.event_type }}
                        </template>
                        <template v-slot:cell(emitter)="data">
                            {{ data.item.event_data.emitter }}
                        </template>
                        <template v-slot:cell(event_message)="data">
                            {{ data.item.event_data.event_message }}
                        </template>
                        <template v-slot:cell(extra_data)="data">
                            {{ data.item.event_data.extra_data }}
                        </template>
                    </b-table>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import Navigation from "@/components/domains/Navigation.vue";
import CcsModal from "@/components/CcsModal.vue";
import ManageDomainGroups from "@/components/domains/ManageDomainGroups.vue";

export default {
    components: {
    },

    metaInfo: {
        title: "Entity Events"
    },

    props: {
    	entity_id: {
    		type: Number,
			default() {
				return 0;
			}
        }
    },

    data: function() {
		let my_table_fields = [
			{
				key: "event_time",
				label: "Time",
				sortable: true
			},
			{
				key: "entity",
				label: "Entity",
				sortable: true
			},
			{
				key: "server_id",
				label: "Server id",
				sortable: true
			},
			{
				key: "event_type",
				label: "Type",
				sortable: true
			},
			{
				key: "emitter",
				label: "Emitter",
				sortable: true
			},
			{
				key: "event_message",
				label: "Message",
				sortable: true
			},
			{
				key: "extra_data",
				label: "Extra data",
				sortable: true
			},
		];
		return {
            is_loading: true,
			table_fields: my_table_fields,
			entity_events: [],
        };
    },

    computed: {
    },

    async mounted() {
        this.getEntityEvents();
        // setInterval((_) => {
        //     this.getDomainsData();
        // }, 5000);
    },

    methods: {
        getEntityEvents() {
            let r = this.$laroute.route("entity_events.get_events", { entity_id: this.entity_id });
            this.$axios
                .get(r)
                .then((response) => {
                	console.log('entity_events', response);
                	this.entity_events = response.data.data;
                })
                .finally((_) => {
                    this.is_loading = false;
                });
        },
    }
};
</script>
